import { render } from "./CustomerPaymentList.vue?vue&type=template&id=c703943c&ts=true"
import script from "./CustomerPaymentList.vue?vue&type=script&lang=ts"
export * from "./CustomerPaymentList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\slow\\slowshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__